var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"toolbar-config":{
    slots: {
      buttons: 'toolbar_form',
    },
  },"columns":_vm.tableColumns,"loading":_vm.loading,"size":"small","resizable":"","border":"","height":235,"header-cell-style":function () {
      return {
        backgroundColor: '#bd94c1',
        color: '#ffffff',
      }
    }},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"specInfo",fn:function(ref){
    var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.spec)+" "+_vm._s(row.specUnit))])]}},{key:"defaultImageUrl",fn:function(ref){
    var row = ref.row;
return [_c('el-image',{staticStyle:{"width":"100px","height":"66px"},attrs:{"src":row.defaultImageUrl
          ? _vm.$osscdn(row.defaultImageUrl)
          : '/image/static/img/nopic.jpg',"preview-src-list":[
        row.defaultImageUrl
          ? _vm.$osscdn(row.defaultImageUrl)
          : '/image/static/img/nopic.jpg' ]}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{staticStyle:{"width":"100px","height":"66px"},attrs:{"src":"/image/static/img/nopic.jpg"}})])])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }